import { createAction, props } from '@ngrx/store';
import { User } from '../model/util/user';

export const loggedIn = createAction(
  '[Login] Successful Login',
  props<{ currentUser: User}>()

);
